import React from 'react';

export const Clock = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      fill="none"
      viewBox="0 0 23 23"
    >
      <path
        stroke="#FF8316"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.875"
        d="M1.137 11.2a10.063 10.063 0 1020.125 0 10.063 10.063 0 00-20.125 0z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#FF8316"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.875"
        d="M16.45 16.45l-4.325-4.323"
      ></path>
      <path
        stroke="#FF8316"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.875"
        d="M9.887 11.2a1.313 1.313 0 102.625 0 1.313 1.313 0 00-2.625 0v0z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#FF8316"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.875"
        d="M11.2 6.388v3.5"
      ></path>
    </svg>
  );
};
